import { Box } from "@mui/material"
import { ClientModal } from "./ClientModal"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SectorData } from "../../types";

interface AddClientProps {
  refetchClients: () => void;
  sectors: SectorData[];
}

export const AddClient = ( { sectors, refetchClients }: AddClientProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate('/clients');
  }

  const handleSave = () => {
    navigate('/clients');
    refetchClients();
  }
  
  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <Box className="add-client">
      <ClientModal open={open} handleClose={handleClose} handleSave={handleSave} sectors={sectors} client={{  }} />
    </Box>
  )
}